import React from "react";
import { auth } from "../auth";
import { redirect } from "next/navigation";

type Props = {
  redirectUrl?: string;
  children: React.ReactNode;
};

export async function SignOut(props: Props) {
  const user = await auth();
  if (user) redirect(props.redirectUrl || "/");
  return props.children;
}
